export default __webpack_public_path__ + "static/media/Scandic_18_x_24.6f2326e8.jpg";